import React from 'react'
import { cn } from '@/utils/cn'
import { useTheme } from '@/hooks/useTheme'

export interface BodyTextProps {
  children: React.ReactNode
  className?: string
  variant?: 'primary' | 'secondary' | 'muted'
  size?: 'sm' | 'md' | 'lg' | 'xl'
  as?: 'p' | 'span' | 'div'
  'data-testid'?: string
}

const BodyText: React.FC<BodyTextProps> = ({
  children,
  className,
  variant = 'primary',
  size = 'md',
  as: Component = 'p',
  'data-testid': testId = 'body-text'
}) => {
  const { isDark } = useTheme()

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  }

  const getVariantClasses = (variant: 'primary' | 'secondary' | 'muted') => {
    switch (variant) {
      case 'primary':
        return isDark ? 'text-white' : 'text-secondary-900'
      case 'secondary':
        return isDark ? 'text-secondary-300' : 'text-secondary-600'
      case 'muted':
        return isDark ? 'text-secondary-400' : 'text-secondary-500'
      default:
        return isDark ? 'text-white' : 'text-secondary-900'
    }
  }

  const combinedClasses = cn(
    sizeClasses[size],
    getVariantClasses(variant),
    className
  )

  return <Component className={combinedClasses} data-testid={testId}>{children}</Component>
}

export { BodyText }